import AboutYouPage from './AboutYouPage';
export default AboutYouPage;
